import { CommonModule, CurrencyPipe } from '@angular/common';
import { AfterViewInit, Component, effect, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatRippleModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { TranslocoModule, TranslocoPipe } from '@jsverse/transloco';
import { AuthService } from 'app/core/auth/auth.service';
import { ApexOptions, NgApexchartsModule } from 'ng-apexcharts';
import { Subject } from 'rxjs';
import { PaymentsOverviewComponent } from './modules/payments-overview/payments-overview.component';
import { TotalRevenueComponent } from '../total-revenue/total-revenue.component';
import { AccountingAdminDashboardService, AccountingAdminDashboardSummaryResponse } from './accounting-dashboard.service';
import { RangeKey, VehicleStockComponent } from '../vehicle-stock/vehicle-stock.component';
import { AlertService } from 'app/core/services/alert.service';

@Component({
  selector: 'app-accounting-dashboard',
  templateUrl: './accounting-dashboard.component.html',
  styleUrls: ['./accounting-dashboard.component.css'],
  imports: [
    TranslocoModule,
    MatIconModule,
    MatButtonModule,
    MatRippleModule,
    MatMenuModule,
    MatTabsModule,
    MatButtonToggleModule,
    NgApexchartsModule,
    MatTableModule,
    MatButtonModule,
    MatDividerModule,
    MatSortModule,
    MatProgressBarModule,
    CommonModule,
    CurrencyPipe,
    PaymentsOverviewComponent,
    TotalRevenueComponent,
    VehicleStockComponent,
    TranslocoPipe
  ]
})
export class AccountingDashboardComponent implements OnInit, OnDestroy, AfterViewInit {

  selectedTabIndex: number = 0;
  chartGithubIssues: ApexOptions = {};
  now = new Date();
  setYear = signal<number>(this.now.getFullYear());
  setPaymentYear = signal<number>(this.now.getFullYear());
  data = signal<AccountingAdminDashboardSummaryResponse>({
    yearlySummary: undefined,
    vehicleStock: undefined,
    completelyPaid: 0,
    completelyPaidSum: 0,
    partiallyPaid: 0,
    partiallyPaidSum: 0,
    unpaid: 0,
    unpaidSum: 0,
    isAbacus: 0,
    isAbacusSum: 0,
    payments: [],
    previousYearPayments: []
  });
  chartVisitors: ApexOptions;
  chartConversions: ApexOptions;
  chartImpressions: ApexOptions;
  chartVisits: ApexOptions;
  chartVisitorsVsPageViews: ApexOptions;
  chartNewVsReturning: ApexOptions;
  chartGender: ApexOptions;
  chartAge: ApexOptions;
  chartLanguage: ApexOptions;
  @ViewChild('recentTransactionsTable', { read: MatSort })
  recentTransactionsTableMatSort: MatSort;
  chartTopSellers: ApexOptions;
  range = signal<RangeKey>('30 days');

  topSellersDataSource: MatTableDataSource<any> =
    new MatTableDataSource();

  defaultColors = [
    '#319795', '#4FD1C5', '#ED8936', '#ECC94B', '#805AD5', '#CBD5E0', '#F56565', '#68D391', '#63B3ED'
  ];

  recentTransactionsTableColumns: string[] = [
    'sellerName',
    'amount',
    'total',
  ];
  private readonly _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(public authService: AuthService, private readonly _accountingService: AccountingAdminDashboardService,
    private readonly _router: Router, private readonly alert: AlertService) {
    effect(() => {
      this.getData();
    });
  }

  getData() {
    this._accountingService.getAccountingAdminDashboardData(this.setPaymentYear(), this.setYear(), this.range()).subscribe({
      next: (response: any) => {
        this.data.set(response.value);
      },
      error: (error) => {
        this.alert.errorFromHttp(error);
      },
    });
  }

  ngOnInit() {
    window['Apex'] = {
      chart: {
        events: {
          mounted: (chart: any, options?: any): void => {
            this._fixSvgFill(chart.el);
          },
          updated: (chart: any, options?: any): void => {
            this._fixSvgFill(chart.el);
          },
        },
      },
    };
  }

  ngAfterViewInit(): void {
    this.topSellersDataSource.sort =
      this.recentTransactionsTableMatSort;
  }

  ngOnDestroy(): void {

    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }

  private _fixSvgFill(element: Element): void {
    // Current URL
    const currentURL = this._router.url;
    Array.from(element.querySelectorAll('*[fill]'))
      .filter((el) => el.getAttribute('fill').indexOf('url(') !== -1)
      .forEach((el) => {
        const attrVal = el.getAttribute('fill');
        el.setAttribute(
          'fill',
          `url(${currentURL}${attrVal.slice(attrVal.indexOf('#'))}`
        );
      });
  }
}

